import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/auth';

const firebaseApp = firebase.initializeApp({
  apiKey: 'AIzaSyBfbhUZbDmtHV7ilbeub4ru3B6JoWkGIRk',
  authDomain: 'insta-clone-msch.firebaseapp.com',
  databaseURL: 'https://insta-clone-msch.firebaseio.com',
  projectId: 'insta-clone-msch',
  storageBucket: 'insta-clone-msch.appspot.com',
  messagingSenderId: '541151348357',
  appId: '1:541151348357:web:7e0df50c714c03c60d8bec',
  measurementId: 'G-2TBWFE8TJG',
});

const db = firebaseApp.firestore();
const auth = firebase.auth();
const storage = firebase.storage();

export { db, auth, storage };
